const translations = {
    noPilotsFound: 'No pilots found',
    search: 'Search pilots'
};

export default translations;
